import { render, staticRenderFns } from "./ProductForm.template.vue?vue&type=template&id=55a7fc68&scoped=true&"
var script = {}
import style0 from "./ProductForm.template.vue?vue&type=style&index=0&id=55a7fc68&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a7fc68",
  null
  
)

export default component.exports